/* GENERAL */
export const HOME = "/";
export const LOGIN = "/login";
export const UI_KIT = "/uikit";
export const STATUS = "/status";

/* LIVE */
export const LIVE_INDEX = "/canli-bahisler"
export const LIVE = "/canli-bahisler/:sportName";
export const LIVE_FOOTBALL = "/canli-bahisler/futbol";
export const LIVE_BASKETBALL = "/canli-bahisler/basketbol";
export const LIVE_TENNIS = "/canli-bahisler/tenis";
export const LIVE_VOLLEYBALL = "/canli-bahisler/voleybol";
export const LIVE_MIXED = "/canli-bahisler/karma";

export const LIVE_PROGRAM_MARKET_LIST = "/canli-bahisler/:sportName/:marketName/";

export const LIVE_MATCH_DETAIL = "/canli-bahisler/:sportName/mac-detay/:streamType/:eventId";

/* LIVE RESULTS */
export const LIVE_RESULTS = "/canli-sonuclar";

/* FIXTURE */
export const FIXTURE_INDEX = "/yaklasan-maclar"
export const FIXTURE = "/yaklasan-maclar/:sportName";
export const FIXTURE_FOOTBALL = "/yaklasan-maclar/futbol";
export const FIXTURE_BASKETBALL = "/yaklasan-maclar/basketbol";
export const FIXTURE_TENNIS = "/yaklasan-maclar/tenis";
export const FIXTURE_VOLLEYBALL = "/yaklasan-maclar/voleybol";

export const FIXTURE_PROGRAM_MARKET_LIST = "/yaklasan-maclar/:sportName/:marketName";

/* MATCH RESULTS */
export const MATCH_RESULTS = "/mac-sonuclari";

/* MULTIPLE SCREENS */
export const MULTIPLE_SCREENS = "/:type-ekran";
export const MULTIPLE_SCREENS_DETAILS = "/tekli-coklu-ekran/detay";

/* KENO */
export const KENO = "/keno";
